
const devPort = window.location.port === '3010'
const isProduction = window.location.hostname.includes('tufirma.digital')

let prodUrl = 'https://api.tufirma.digital';
/*
let moneda = Math.random()*10;
//console.log("Moneda:", moneda);
if(moneda>5){
  //console.log("apib");
  prodUrl = 'https://apib.tufirma.digital';
} else {
  //console.log("api");
}
  */

var baseURL = devPort
  ? `http://${window.location.hostname}:3000`
  : isProduction
    ? prodUrl
    : `http://${window.location.hostname}:3000`
// `http://${window.location.hostname}:3000`

//baseURL = 'https://testapi.tufirma.digital'
//Overrida segun sub-dominio

if(window.location.hostname.includes('test.tufirma')){
  baseURL='https://testApi.tufirma.digital'
}
if(window.location.hostname.includes('testlab.tufirma')){
  baseURL='https://apib.tufirma.digital'
}

if(window.location.hostname.includes('eurocapital.tufirma.digital')){
  baseURL='https://api2.tufirma.digital'
}

//baseURL = 'https://testapi.tufirma.digital'
//const baseURL = 'http://localhost:3000'
//const baseURL = 'http://${window.location.hostname}:3000'

export default baseURL



// WEBPACK FOOTER //
// ./src/App/Root/url.js